module.exports = __webpack_public_path__ + "img/11.ef1223ab.png";